
import { defineComponent, PropType } from 'vue';
import { hashColorClassNames } from '@/utils/colors';
import { SelectedCourse } from '../../../types';

export default defineComponent({
  props: {
    course: { type: Object as PropType<SelectedCourse>, required: true },
  },
  emits: ['show-detail', 'delete-course'],
  computed: {
    classCourseCard(): string[] {
      return [
        hashColorClassNames(
          (this.course.code && parseInt(this.course.code.slice(this.course.code.length - 3), 10))
            || 0,
        ),
      ];
    },
  },
  methods: {
    /** 点击详情按钮 */
    handleClickDetailButton() {
      this.$emit('show-detail', this.course.id);
    },
    /** 点击删除按钮 */
    handleClickDeleteButton() {
      this.$emit('delete-course', this.course.id);
    },
  },
});
